// TED (Tenders Electronic Daily) URL utilities

/**
 * Generate the PDF download URL for a TED notice
 * TED notice IDs are typically in format: 123456-2024
 * The PDF URL format is: https://ted.europa.eu/udl?uri=TED:NOTICE:{noticeId}:PDF:{lang}:PDF
 */
export function getTedPdfUrl(noticeId: string, language: string = 'IT'): string {
  // Clean the notice ID
  const cleanId = noticeId.replace(/\s+/g, '').toUpperCase();
  
  return `https://ted.europa.eu/udl?uri=TED:NOTICE:${cleanId}:PDF:${language}:PDF`;
}

/**
 * Generate the HTML view URL for a TED notice
 */
export function getTedHtmlUrl(noticeId: string, language: string = 'IT'): string {
  const cleanId = noticeId.replace(/\s+/g, '').toUpperCase();
  
  return `https://ted.europa.eu/udl?uri=TED:NOTICE:${cleanId}:TEXT:${language}:HTML`;
}

/**
 * Get TED notice URL from the official portal
 */
export function getTedNoticeUrl(noticeId: string): string {
  const cleanId = noticeId.replace(/\s+/g, '');
  
  return `https://ted.europa.eu/notice/${cleanId}`;
}

/**
 * Available TED document languages
 */
export const TED_LANGUAGES = [
  { code: 'IT', name: 'Italiano' },
  { code: 'EN', name: 'English' },
  { code: 'DE', name: 'Deutsch' },
  { code: 'FR', name: 'Français' },
  { code: 'ES', name: 'Español' },
  { code: 'PT', name: 'Português' },
  { code: 'NL', name: 'Nederlands' },
  { code: 'PL', name: 'Polski' },
  { code: 'RO', name: 'Română' },
  { code: 'EL', name: 'Ελληνικά' },
] as const;
